import BaseModel from './BaseModel.js';
export default class ColumnModel {
    constructor(arg) {
        const me = this;
        if (typeof arg == 'object') {
            for (let key in arg) {
                if (me.hasOwnProperty(key)) {
                    me[key] = arg[key];
                }
            }
        }
    };
    _getPropertyHasOwnValue() {
        let ret = {};
        for (let key in this) {
            if (this[key] !== null && this[key] !== undefined) {
                ret[key] = this[key];
            }
        }
        return ret;
    };
    //Nội dung hiện thị
    title = undefined;
    //Độ rộng của cột
    width = undefined;
    //Data mapping
    dataField = undefined;
    //Tooltip hiển thị
    tooltip = undefined;
    //Trạng thái ẩn hiện
    visiable = undefined;
    //Enum
    enumName = undefined;
    //formatType
    formatType = undefined;
    //Căn lề
    align = undefined;
    // style cho cột
    cssClass = undefined;
    //format type
    formatOptions = undefined;

    //Bổ sung phục vụ cột là icon
    //Cột có phải icon hay không
    isIcon = undefined;
    //class css của cell
    cssCellClass = undefined;
    //class của icon
    class = undefined;
    //class acitve của icon
    classActive = undefined;
    //Không cho phép cột thiếp lập co giãn
    notResize = undefined;
    isSort = undefined;
    iconAfterTitle = undefined;
    tooltipIconAfterTitle = undefined;
    isWrapText = undefined;
    isFilter = undefined;
}